import Switcher from "@components/switcher/Switcher";
import UnifiedTransactionCounterpartyDetails from "./UnifiedTransactionCounterpartDetails";
import UnifiedTransactionDetails from "./UnifiedTransactionDetails";

interface UnifiedTransactionTabsProps {
  transactionId: number;
  merchantId: number | undefined;
  ledger?: string;
  merchantOrderId?: string;
}

const UnifiedTransactionTabs: React.FC<UnifiedTransactionTabsProps> = ({
  transactionId,
  merchantId,
  ledger,
  merchantOrderId,
}) => {
  const tabs = [
    {
      label: "TRANSACTION",
      component: (
        <UnifiedTransactionDetails
          transactionId={transactionId}
          merchantId={merchantId}
        />
      ),
    },
    {
      label: "COUNTERPARTY",
      component: (
        <UnifiedTransactionCounterpartyDetails
          transactionId={transactionId}
          ledger={ledger}
          merchantId={merchantId}
          merchantOrderId={merchantOrderId}
          source="unified"
        />
      ),
    },
  ];
  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default UnifiedTransactionTabs;
